<template>
	<div>
		<div class="foot-nav-height"></div>
		<div class="foot-nav">
			<div class="nav-scroll" ref="navScroll">
				<div class="nav-inner">
					<template v-for="(item,index) in list">
						<router-link class="nav-item" :to="item.url" :key="'link-'+index" v-if="item.url" ref="navItems">
							<span class="nav-label" :class="{'auto':item.name.length<4}">{{item.name}}</span>
						</router-link>
						<div class="nav-item" :key="'div-'+index" v-else ref="navItems">
							<span class="nav-label" :class="{'auto':item.name.length<4}">{{item.name}}</span>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "i-nav",
		props: {
			index: {
				type: [Number,String],
				default: 0
			},
		},
		data() {
			return {
				list:[
					{
						name:"任务指南",
						url:"/task-guide"
					},
					{
						name:"培训议程",
						url:"/training-agenda"
					},
					{
						name:"玩家集结",
						url:"/collect"
					},
					{
						name:"任务打卡",
						url:"/task-checkin"
					},
					{
						name:"积分排行",
						url:"/points-ranking"
					},
					{
						name:"会议资料",
						url:"/files"
					},{
						name:"活动相册",
						url:"/photo-album"
					},
				]
			};
		},
		mounted() {
			this.$nextTick(() => {
				this.scrollToActive();
			});
		},
		watch: {
			'$route'() {
				this.$nextTick(() => {
					this.scrollToActive();
				});
			}
		},
		methods: {
			scrollToActive() {
				const scrollEl = this.$refs.navScroll;
				if (!scrollEl) return;
				const items = this.$refs.navItems;
				if (!items) return;
				const itemArr = Array.isArray(items) ? items : [items];
				for (let i = 0; i < itemArr.length; i++) {
					const el = itemArr[i].$el || itemArr[i];
					if (el && el.classList && el.classList.contains('router-link-active')) {
						const itemLeft = el.offsetLeft;
						const itemWidth = el.offsetWidth;
						const scrollWidth = scrollEl.offsetWidth;
						scrollEl.scrollLeft = itemLeft - (scrollWidth - itemWidth) / 2;
						break;
					}
				}
			}
		},
	};
</script>
<style lang="less" scoped>
	.foot-nav-height {
		height: 140px;
	}

	.foot-nav {
		height: 140px;
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		z-index: 88;
		background: rgba(255, 255, 255, 0.82);
		-webkit-backdrop-filter: saturate(180%) blur(30px);
		backdrop-filter: saturate(180%) blur(30px);
		border-top: 0.5px solid rgba(0, 0, 0, 0.06);
		display: flex;
		align-items: center;
	}

	.nav-scroll {
		width: 100%;
		overflow-x: auto;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
		padding: 0 14px;
		scrollbar-width: none;
		&::-webkit-scrollbar {
			display: none;
		}
	}

	.nav-inner {
		display: inline-flex;
		white-space: nowrap;
		gap: 12px;
		padding: 0 4px;
	}

	.nav-item {
		width: 120px;
		height: 96px;
		border-radius: 14px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.03);
		text-decoration: none;
		flex-shrink: 0;
		transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
					transform 0.15s ease;

		&:active {
			transform: scale(0.95);
		}

		.nav-label {
			text-align: center;
			width: 2.5em;
			line-height: 1.4em;
			font-size: 26px;
			font-weight: 500;
			color: #86868b;
			white-space: pre-wrap;
			transition: color 0.3s ease;
		}

		.auto {
			width: 100%;
		}
	}

	.router-link-active {
		background: rgba(0, 122, 255, 0.1);

		.nav-label {
			color: #007AFF;
			font-weight: 600;
		}
	}
</style>
